import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import customFetch from '../utils/customFetch';

export type NotificationPrefs = {
  enabled: boolean;
  frequency: 'immediate' | 'hourly' | 'daily' | 'weekly' | 'off';
  additional_emails?: string[] | string; // Can be array or comma-separated string
};

export function useGetNotificationPrefs() {
  return useQuery({
    queryKey: ['notification-prefs'],
    queryFn: async () => {
      const res = await customFetch('/v1/notifications/preferences');
      if (!res.ok) throw new Error('Failed to fetch notification preferences');
      return res.json();
    },
  });
}

export function useUpdateNotificationPrefs() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (body: NotificationPrefs) => {
      const res = await customFetch('/v1/notifications/preferences', {
        method: 'PUT',
        body: JSON.stringify(body),
      });
      if (!res.ok) throw new Error('Failed to update notification preferences');
      return res.json();
    },
    onSuccess: () => qc.invalidateQueries({ queryKey: ['notification-prefs'] }),
  });
}


